import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const style = makeStyles((theme) => ({
  btn: {
    marginTop: theme.spacing(1),
    textAlign: 'right',
  },
}));

const NotificationTooltip = (props) => {
  const classes = style();
  const [open, setOpened] = React.useState(props.startOpen);

  const handleClose = () => setOpened(false);
  const handleOpen = () => setOpened(true);

  return (
    <>
      <Tooltip
        arrow
        open={open}
        id="notification-tooltip"
        classes={props.classes}
        onClose={(e) => {
          if (e && e.type === 'touchend') {
            return;
          }

          handleClose();
        }}
        onOpen={handleOpen}
        interactive
        title={(
          <>
            {props.title}
            {
              props.showButton && (
                <div className={classes.btn}>
                  <Button
                    size="small"
                    type="button"
                    onClick={() => {
                      if (props.onButtonClick) {
                        props.onButtonClick();
                      }

                      handleClose();
                    }}
                    color="primary"
                  >
                    <FormattedMessage id="got it" defaultMessage="got it" />
                  </Button>
                </div>
              )
            }
          </>
        )}
      >
        {props.children}
      </Tooltip>
    </>
  );
};

NotificationTooltip.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  startOpen: PropTypes.bool,
  classes: PropTypes.shape({}),
  showButton: PropTypes.bool,
  onButtonClick: PropTypes.func,
};

export default NotificationTooltip;
